<template>
  <v-card class="bg-transparent" flat>
    <!-- 1、2層內容 -->
    <ListArea
      :options="{
        editedAuth,
        data: contenList.container,
        limitContentHeight
      }"
    />
    <v-card-text class="pa-0">
      <v-list class="bg-transparent" expand>
        <!-- noData -->
        <template v-for="menu in contenList.menus">
          <div :key="menu.menuId" class="pb-10-px">
            <v-btn text class="fz-20-px" :href="getUrl(menu)">
              <v-icon left dark class="grey--text text--darken-2 fz-24-px">
                mdi-folder
              </v-icon>
              <template v-if="menu[topicKey]">
                {{ menu[topicKey] }}
              </template>
              <template v-else>{{ menu.topic }}</template>
            </v-btn>
          </div>
        </template>
        <!-- 3 -->
        <template v-for="(item, index) in childrenList">
          <v-slide-x-reverse-transition mode="out-in" :key="'card-' + index">
            <v-list-group
              active-class="grey--text text--darken-2"
              class="pa-0"
              v-model="item.active"
              :ref="item.refKey"
            >
              <template v-slot:activator>
                <v-list-item-content class="pa-0">
                  <Title
                    :index="index"
                    :data="item"
                    :hoverColor="contentHoverColor"
                    :modifyMode="modifyMode"
                    :editedAuth="editedAuth"
                  ></Title>
                </v-list-item-content>
              </template>

              <v-card class="bg-transparent pl-56-px pb-10-px" flat>
                <ListArea
                  v-if="item.list.length > 0 || modifyMode.show"
                  :options="{
                    editedAuth,
                    data: item,
                    limitContentHeight
                  }"
                />

                <!-- 4 -->
                <v-list-item
                  v-for="(sub, sub_i) in item.children"
                  :key="'list-item-' + index + '-' + sub_i"
                  :value="item.menu_id"
                  :ref="sub.refKey"
                  class="pl-0-px"
                >
                  <v-list-item-content class="py-0">
                    <Title
                      :index="index + '-' + sub_i"
                      :data="sub"
                      :hoverColor="contentHoverColor"
                      :modifyMode="modifyMode"
                      :editedAuth="editedAuth"
                    ></Title>
                    <div class="pl-56-px pb-30-px">
                      <ListArea
                        v-if="sub.list.length > 0 || modifyMode.show"
                        :options="{
                          editedAuth,
                          data: sub,
                          limitContentHeight
                        }"
                      />
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-list-group>
          </v-slide-x-reverse-transition>
        </template>
      </v-list>
    </v-card-text>
    <template v-if="editedAuth && modifyMode.show">
      <v-btn
        class="left-380-px grey darken-3 z-index-8"
        elevation="5"
        dark
        fab
        fixed
        left
        bottom
        :title="limitContentHeight ? '全部內文' : '部分內文'"
        @click.stop="setContentHeight()"
      >
        <v-icon>
          {{
            limitContentHeight
              ? 'mdi-unfold-more-horizontal'
              : 'mdi-unfold-less-horizontal'
          }}
        </v-icon>
      </v-btn>
    </template>
    <v-btn
      v-if="childrenList.length > 0"
      class="showAllContentBtn grey darken-3"
      elevation="5"
      dark
      fab
      fixed
      right
      bottom
      @click.stop="
        () => {
          switchShowAllContent(!showAllContent)
        }
      "
      ><v-icon>{{
        !switchShowAllContentDone
          ? 'mdi-loading'
          : showAllContent
          ? 'mdi-chevron-down'
          : 'mdi-chevron-up'
      }}</v-icon></v-btn
    >
    <v-btn
      v-show="offsetTop"
      class="scrollTopBtn grey darken-3"
      elevation="5"
      dark
      fab
      fixed
      right
      bottom
      v-scroll="onScroll"
      @click.stop="scrollMeTo('ref-top')"
      ><v-icon>mdi-publish</v-icon></v-btn
    >
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import ListArea from './ContentListArea.vue'

import Title from '@/components/elements/contentType/Title.vue'

export default {
  name: 'contentList',

  provide() {
    return {
      mapResult: this.mapResult
    }
  },

  inject: ['scrollMeTo'],

  props: ['contenList', 'editedAuth'],

  components: {
    ListArea,
    Title
  },

  data() {
    return {
      contentHoverColor: '#033c63',
      currListGroup: 3,
      childrenList: [],
      offsetTop: false,
      limitContentHeight: false,
      showAllContent: false,
      switchShowAllContentDone: true
    }
  },

  computed: {
    ...mapState('common', ['modifyMode', 'lang']),
    ...mapState('document', ['createMode', 'versionData']),
    topicKey() {
      return this.lang === 'en' ? 'topicEn' : 'topic'
    }
  },

  watch: {
    contenList: {
      handler: function (newVal, oldVal) {
        this.childrenList = []
        if (newVal.children.length > 0) {
          const list = JSON.parse(JSON.stringify(this.contenList.children))
          this.childrenList = list
          const refKey = this.$route.query.ref
          if (refKey) {
            const refArr = refKey.split('_')
            const id = refArr[1] > 3 ? refArr[2] : refArr[3]
            this.childrenList.find((item) => {
              return parseInt(item.menuId) === parseInt(id)
            }).active = true
            this.$nextTick(() => {
              this.scrollMeTo(refKey)
            })
          }
          if (newVal !== oldVal) {
            this.setTableWidth()
          }
        }
      },
      deep: true,
      immediate: true
    }
  },

  created() {
    this.$watch(
      () => this.$route.query,
      (toQuery, previousQuery) => {
        this.$nextTick(() => {
          if (toQuery.ref) {
            this.scrollMeTo(toQuery.ref)
            this.setTableWidth()
          }
        })
      }
    )
  },

  methods: {
    ...mapActions('message', ['setSnackbar']),
    ...mapActions('document', ['setCurrentContent', 'setDialogChapter']),
    setTableWidth() {
      setTimeout(() => {
        this.$nextTick(() => {
          const tables = window.$('table')
          for (let i = 0; i < tables.length; i++) {
            const table = window.$(tables[i])
            const ml = table.css('margin-left')
            const pattern = /^width:/g
            const res = pattern.test(table.attr('style'))
            if (ml && ml !== '0px' && res && !table.hasClass('StyleEdited')) {
              const mlNum = parseInt(ml.split('p')[0])
              const w = 'calc(100% - ' + mlNum + 'px)'
              table.css('width', w)
              table.addClass('StyleEdited')
            }
          }
        })
      }, 500)
    },
    getUrl(menu) {
      return this.$route.path + '?menuId=' + menu.menuId
    },
    mapResult() {
      this.setSnackbar({ show: true, text: 'SUCCESS' })
      const queryMenuId = this.$route.query.menuId
      this.$api.common.leaf.getCtxesByMenuId4All(queryMenuId).then((res) => {
        this.setCurrentContent(res)
        this.setDialogChapter()
      })
    },
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollingElement.offsetTop || 0
      this.offsetTop = top > 20
    },
    switchShowAllContent(val) {
      this.showAllContent = val
      this.switchShowAllContentDone = false
      for (const i in this.childrenList) {
        this.childrenList[i].active = val
      }
      this.switchShowAllContentDone = true
    },
    setContentHeight() {
      this.limitContentHeight = !this.limitContentHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.html {
  letter-spacing: 1px;
}
.scrollTopBtn {
  opacity: 0.8;
  margin-bottom: 60px;
}
.showAllContentBtn {
  opacity: 0.8;
}
</style>
